import { render, staticRenderFns } from "./verArchivoProp.vue?vue&type=template&id=f99493a8"
import script from "./verArchivoProp.vue?vue&type=script&lang=js"
export * from "./verArchivoProp.vue?vue&type=script&lang=js"
import style0 from "./verArchivoProp.vue?vue&type=style&index=0&id=f99493a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports